import { instance } from '../lib/api'
import { API_FAIL } from '../actions/dashboard'
import {
  LOAD_COUNT_DECREMENT,
  LOAD_COUNT_INCREMENT,
  SHOW_SNACKBAR_TOASTR
} from '../actions/loading'
import Constants from '../utils/CommonConstants'

export const UPDATE_ORDER_DOCUMENTS = 'UPDATE_ORDER_DOCUMENTS'
export const UPDATE_DEVELOPER_DETAILS = 'UPDATE_DEVELOPER_DETAILS'
export const UPDATE_LEGAL_ENTITIES = 'UPDATE_LEGAL_ENTITIES'
export const REFRESH_BROKER_DOCUMENTS = 'REFRESH_BROKER_DOCUMENTS'
export const DELETE_ORDER_DOCUMENTS = 'DELETE_ORDER_DOCUMENTS'
export const ORDER_DETAILS_UPDATED = 'ORDER_DETAILS_UPDATED'
export const PAYMENT_MODE_UPDATED = 'PAYMENT_MODE_UPDATED'
export const INVOICE_DELETED = 'INVOICE_DELETED'
export const ORDER_REFRESHED = 'ORDER_REFRESHED'
export const REASON_LIST = 'REASON_LIST'
export const ORDER_GET = 'ORDER_GET'

export const deleteOrderDocuments = orderCaseId => {
  return dispatch => {
    dispatch({
      type: DELETE_ORDER_DOCUMENTS,
      orderCaseId
    })
  }
}

export const deleteOrderInvoice = (invoiceId, generateNewInvoice) => {
  return dispatch => {
    const url = `/sapna/v1/invoice/${invoiceId}?generateNewInvoice=${Boolean(generateNewInvoice)}`
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: 'Deleting invoice.'
    })
    return instance({
      url,
      method: 'DELETE'
    })
      .then(response => {
        dispatch({
          type: INVOICE_DELETED
        })
      })
      .catch(error => {
        dispatch({
          type: API_FAIL,
          errMsg: Constants.getErrorMessage(error)
        })
      })
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const getOrderDocuments = (
  caseId,
  objectId,
  objectType,
  caseSubTypeId,
  documentType
) => {
  return dispatch => {
    let url = `/pixie/data/v1/entity/document?objectId=${objectId}&objectType=${objectType}&domainId=${Constants.makaanCaseSubTypes.includes(caseSubTypeId) ? Constants.domainId.MAKAAN : Constants.domainId.HOUSING}`
    if (documentType) {
      url += `&documentType=${documentType}`
    }
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: `Fetching ${objectType} documents.`
    })
    return instance({
      url,
      method: 'GET'
    })
      .then(response => {
        if (response.data.data) {
          let documents = {}
          response.data.data.forEach(element => {
            const type = element.objectMediaType.displayName
            if (documents[type]) {
              documents[type].push({
                url: element.absoluteUrl,
                createdAt: Constants.epochToDateTime(element.createdAt)
              })
            } else {
              documents[type] = [
                {
                  url: element.absoluteUrl,
                  createdAt: Constants.epochToDateTime(element.createdAt)
                }
              ]
            }
          })
          dispatch({
            type: UPDATE_ORDER_DOCUMENTS,
            id: caseId,
            documents
          })
        }
      })
      .catch(() => {
        dispatch({
          type: API_FAIL
        })
      })
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const getDeveloperDetails = accountId => {
  return dispatch => {
    let url = `/sapna/v1/account/${accountId}`
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: `Fetching account details.`
    })
    return instance({
      url,
      method: 'GET'
    })
      .then(response => {
        if (response.data.data) {
          dispatch({
            type: UPDATE_DEVELOPER_DETAILS,
            id: accountId,
            detail: response.data.data
          })
        }
      })
      .catch(() => {
        dispatch({
          type: API_FAIL
        })
      })
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const getAccountLegalEntityDetails = accountId => {
  return dispatch => {
    let url = `/sapna/v2/account-legal-entity/account/${accountId}`
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: `Fetching account legal entity details.`
    })
    return instance({
      url,
      method: 'GET'
    })
      .then(response => {
        if (response.data.data) {
          dispatch({
            type: UPDATE_LEGAL_ENTITIES,
            id: accountId,
            detail: response.data.data
          })
        }
      })
      .catch(() => {
        dispatch({
          type: API_FAIL
        })
      })
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const getOrderDetails = orderCaseId => {
  return dispatch => {
    const url = Constants.configUrls.ORDER_GET(orderCaseId)
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: 'Fetching order details.'
    })
    instance({
      url,
      method: 'GET'
    })
      .then(
        response => {
          if (response.data.data) {
            dispatch({
              type: ORDER_GET,
              order: response.data.data
            })
          } else {
            dispatch({
              type: SHOW_SNACKBAR_TOASTR,
              message: 'Order does not exist.'
            })
          }
        },
        error => {
          const snackbarMessage =
            (error.response &&
              error.response.data &&
              error.response.data.error &&
              error.response.data.error.msg) ||
            'Error occured in getting details.'
          dispatch({ type: SHOW_SNACKBAR_TOASTR, message: snackbarMessage })
        }
      )
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const getOrderCommentReasons = ({ currentStatusId, caseSubTypeId }) => {
  const reasonListUrl = Constants.configUrls.REASON_LIST(
    currentStatusId,
    caseSubTypeId
  )
  return dispatch => {
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: 'Fetching comment reasons....'
    })
    instance({
      url: reasonListUrl,
      method: 'GET'
    })
      .then(response => {
        dispatch({
          type: REASON_LIST,
          reasonList: response.data.data.results
        })
      })
      .catch(err => {
        dispatch({
          type: SHOW_SNACKBAR_TOASTR,
          message: 'Error occured in fetching case reasons.'
        })
      })
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const refreshBrokerOrderDocuments = orderCaseId => {
  const url = Constants.configUrls.ORDER_GET(orderCaseId)
  return dispatch => {
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: 'Fetching order documents....'
    })
    instance({
      url,
      method: 'GET'
    })
      .then(
        response => {
          if (
            response.data.data &&
            response.data.data.platform_order_details.documents
          ) {
            const brokerDocuments =
              response.data.data.platform_order_details.documents
            dispatch({
              type: REFRESH_BROKER_DOCUMENTS,
              brokerDocuments
            })
          } else {
            dispatch({
              type: SHOW_SNACKBAR_TOASTR,
              message: 'Error in updating documents.'
            })
          }
        },
        error => {
          this.props.dispatch({
            type: SHOW_SNACKBAR_TOASTR,
            message: 'Error in updating documents.'
          })
        }
      )
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const saveOrderDetails = (data, url) => {
  return dispatch => {
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: 'Updating order details.'
    })
    instance({
      url,
      data,
      method: 'PUT'
    })
      .then(
        response => {
          dispatch({
            type: SHOW_SNACKBAR_TOASTR,
            message: 'Order updated Successfully.'
          })
          dispatch({ type: ORDER_DETAILS_UPDATED })
        },
        error => {
          const message =
            (error.response &&
              error.response.data &&
              error.response.data.error &&
              error.response.data.error.msg) ||
            'Error occured in getting details.'
          dispatch({
            type: SHOW_SNACKBAR_TOASTR,
            message
          })
        }
      )
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const editPaymentModeDetails = (data, url) => dispatch => {
  dispatch({
    type: LOAD_COUNT_INCREMENT,
    message: 'Updating payment mode details.'
  })
  instance({
    url,
    data,
    method: 'POST'
  })
    .then(
      response => {
        dispatch({
          type: SHOW_SNACKBAR_TOASTR,
          message: 'Payment mode updated Successfully.'
        })
        dispatch({ type: PAYMENT_MODE_UPDATED })
      },
      error => {
        // TODO: Method chaining can be done here after upgrading babel package
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.error &&
            error.response.data.error.msg) ||
          'Error occured in getting details.'
        dispatch({
          type: SHOW_SNACKBAR_TOASTR,
          message
        })
      }
    )
    .finally(() => {
      dispatch({
        type: LOAD_COUNT_DECREMENT
      })
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/order.js
 **/